if (!customElements.get('yrp-desktop-gallery')) {
  customElements.define('yrp-desktop-gallery', class extends HTMLElement {
    connectedCallback() {
      this.list = this.closest('slider-component')?.querySelector('.product__media-list');
      if (!this.list) return;
      this.desktop = matchMedia('(min-width: 990px)');
      this.onViewport = () => this.refresh();
      this.onClick = event => {
        const button = event.target.closest('button[data-media-id]');
        if (button && this.contains(button)) this.select(button.dataset.mediaId);
      };
      this.product = this.closest('.product');
      this.onVariantChange = event => {
        const picker = event.target.closest('variant-radios, variant-selects');
        if (!picker || !this.desktop.matches) return;
        queueMicrotask(() => {
          const mediaId = picker.currentVariant?.featured_media?.id;
          if (mediaId) this.select(picker.dataset.section + '-' + mediaId);
        });
      };
      this.product?.addEventListener('change', this.onVariantChange);
      this.desktop.addEventListener('change', this.onViewport);
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.refresh(true));
      this.observer.observe(this.list, { childList: true });
      this.refresh();
    }
    reset() {
      this.list.classList.remove('yrp-desktop-gallery-ready');
      Array.from(this.list.children).forEach(item => {
        item.classList.remove('yrp-desktop-gallery-active');
        item.removeAttribute('aria-hidden');
        item.removeAttribute('inert');
      });
      this.hidden = true;
    }
    refresh(useFirst = false) {
      this.reset();
      if (!this.desktop.matches) return;
      this.items = Array.from(this.list.children).filter(item => item.matches('.product__media-item') && getComputedStyle(item).display !== 'none');
      if (this.items.length < 2) return;
      const id = !useFirst && this.items.some(item => item.dataset.mediaId === this.activeId) ? this.activeId : this.items[0].dataset.mediaId;
      this.replaceChildren(...this.items.map((item, index) => {
        const button = document.createElement('button');
        const image = item.querySelector('img');
        button.type = 'button';
        button.dataset.mediaId = item.dataset.mediaId;
        button.setAttribute('aria-label', (image?.alt || this.getAttribute('aria-label') || '') + ' (' + (index + 1) + '/' + this.items.length + ')');
        if (image) {
          const preview = image.cloneNode(false);
          preview.removeAttribute('id');
          preview.alt = '';
          preview.sizes = '80px';
          preview.loading = 'lazy';
          button.append(preview);
        }
        return button;
      }));
      this.list.classList.add('yrp-desktop-gallery-ready');
      this.hidden = false;
      this.select(id);
    }
    select(id) {
      if (!this.desktop.matches || !this.items.some(item => item.dataset.mediaId === id)) return;
      this.activeId = id;
      this.items.forEach(item => {
        const active = item.dataset.mediaId === id;
        item.classList.toggle('yrp-desktop-gallery-active', active);
        if (active) {
          item.removeAttribute('aria-hidden');
          item.removeAttribute('inert');
        } else {
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('inert', '');
          item.querySelectorAll('video').forEach(video => video.pause());
        }
      });
      Array.from(this.children).forEach(button => {
        button.setAttribute('aria-current', button.dataset.mediaId === id ? 'true' : 'false');
      });
    }
    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.onViewport);
      this.product?.removeEventListener('change', this.onVariantChange);
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      if (this.list) this.reset();
    }
  });
}
